import { render, staticRenderFns } from "./CreateWidget.vue?vue&type=template&id=38d7067e&scoped=true&"
import script from "./CreateWidget.vue?vue&type=script&lang=js&"
export * from "./CreateWidget.vue?vue&type=script&lang=js&"
import style0 from "./CreateWidget.vue?vue&type=style&index=0&id=38d7067e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7067e",
  null
  
)

export default component.exports